<template>
	<div class="print_container full" v-loading="loading">
		<div class="print_header flex">
			<el-button type="primary" v-print="printObj" size="mini">打印</el-button>
			<el-button type="primary" @click="exportdata" size="mini">导出excle</el-button>
			<el-button type="primary" @click="download" size="mini">下载图片</el-button>
			<el-button type="primary" @click="downloadPDF" size="mini">下载PDF</el-button>
			<!-- <el-button type="danger" style="position: absolute;right: 10px;" @click="back">返回</el-button> -->
		</div>
		<div class="print full">
			<div class="print_paper" v-show="printShow">
				<div class="print_content" id="print_content" ref="printContent"
					style="-webkit-print-color-adjust: exact;">
					<div class="header flex">
						<div class="header_title">报价单</div>
						<div class="header_notice">
							<!-- <div style="font-weight: bold;">温州纳智紧固件有限公司</div> -->
							<div style="font-weight: bold;" v-if="company">{{company}}</div>
							<template v-else>
								<div style="font-weight: bold;">温州纳智紧固件有限公司</div>
								<div style="font-weight: bold;">佛山纳智五金制品有限公司</div>
							</template>
							<!-- <div style="font-size: 12px;">专业生产螺丝、螺母、气动元件；</div> -->
						</div>
					</div>
					<div class="body">
						<vxe-table border :data="infoData" :merge-cells="mergeCells" size="mini" :show-header="false"
							style="width: 100%;">
							<vxe-column field="a" title=""></vxe-column>
							<vxe-column field="b" title=""></vxe-column>
							<vxe-column field="c" title=""></vxe-column>
							<vxe-column field="d" title=""></vxe-column>
							<vxe-column field="e" title=""></vxe-column>
							<vxe-column field="f" title=""></vxe-column>
							<vxe-column field="g" title=""></vxe-column>
							<vxe-column field="h" title=""></vxe-column>
						</vxe-table>
						<vxe-table border :data="tableData" size="mini" :header-cell-class-name="headerCellClassName"
							:cell-class-name="cellClassName" style="width: 100%;">
							<vxe-column type="seq" width="50"></vxe-column>
							<vxe-column field="goodscode" title="商品编码" width="100"></vxe-column>
							<vxe-column field="goodsname" title="商品名称"></vxe-column>
							<vxe-column field="goodsmodel" title="规格"></vxe-column>
							<vxe-column field="num" title="数量"></vxe-column>
							<vxe-column field="goodsunit" title="单位">
								<template #default="{row}">{{getEmunValue('unit',row.goodsunit)}}</template>
							</vxe-column>
							<vxe-column field="taxfreight" title="单价"></vxe-column>
							<vxe-column field="amount" title="金额小计"></vxe-column>
							<vxe-column field="mark" title="产品备注"></vxe-column>
						</vxe-table>
						<vxe-table border :data="resData" size="mini" :show-header="false"
							style="width: 100%;margin-top: 10px;">
							<vxe-column field="a" title="ERP编码"></vxe-column>
							<vxe-column field="b" title="商品名称"></vxe-column>
							<vxe-column field="c" title="规格"></vxe-column>
							<vxe-column field="d" title="数量"></vxe-column>
							<vxe-column field="e" title="数量"></vxe-column>
							<vxe-column field="f" title="单位"></vxe-column>
						</vxe-table>
						<vxe-table border :data="collectionData" size="mini"
							:header-cell-class-name="headerCellClassName" style="width: 550px;margin-top: 20px;">
							<vxe-column type="seq" width="50"></vxe-column>
							<vxe-column field="collectionaccount" title="收款账户" width="200"></vxe-column>
							<vxe-column field="amount" title="收款金额" width="100"></vxe-column>
							<vxe-column field="invoiceattr" title="发票类型" width="200">
								<template #default="{row}">
									<span
										v-if="row.collectionaccount">{{getEmunValue('invoiceattr',row.invoiceattr)+row.tax+'%'}}</span>
									<span v-else>现金</span>
								</template>

							</vxe-column>
						</vxe-table>
						<div class="body_part2">
							<div>订单备注：{{mark}}</div>
							<div style="margin-top: 20px;font-weight: bold;">付款条件：全额付款后，标准件产品默认72小时内发货</div>
						</div>
						<div class="body_part3">
							<!-- 							<div>温州纳智紧固件有限公司</div>
							<div style="margin-top: 10px;">浙江省温州市鹿城区机场大道蒲盛路53号长江电器4楼</div> -->

							<div v-if="company">所属公司：{{company}} </div>
							<div v-else>所属公司：{{companys[0]?companys[0].name:''}}</div>
							<div style="margin-top: 10px;" v-if="companyaddress">公司地址：{{companyaddress}}</div>
							<div style="margin-top: 10px;" v-else>公司地址：{{companys[0]?companys[0].address:''}}</div>
							<!-- <div style="margin-top: 10px;">客服电话：{{staffphone}}</div> -->
<!-- 							<div style="margin-top: 10px;">紧急联系人：
								<span>孙经理15869629958 </span>
							</div> -->
							<div style="margin-top: 10px;">
								<span>禁止客服私收货款，投诉热线 </span>
								<span>{{offerphone?offerphone:staffphone}} </span>
								<!-- 								<template v-for="(item,index) in director">
									<span v-if="item.phone" :key="index" style="margin-right: 5px;">
										<span>{{item.phone}}</span>
										<span v-if="index<(director.length-1)">,</span>
									</span>
								</template> -->
								<span>投诉成功奖励500元</span>
							</div>
						</div>
						<!-- 						<div class="body_part4">
							<div>付款账户：温州纳智紧固件有限公司 </div>
						</div> -->
					</div>
					<div v-if="seal" style="position: absolute;width: 120px;height: 120px;bottom: 20px;right:20px;">
						<img crossOrigin="anonymous" class="full" :src="seal">
					</div>
				</div>
			</div>
		</div>




	</div>
</template>
<style scoped>
	.header {
		position: relative;
		width: 100%;
		color: white;
		background-color: black;
		top: 0;
		flex-direction: row;
		align-items: center;
		box-sizing: border-box;
		padding: 4px 0;
	}

	.header_notice {
		font-size: 14px;
		margin-right: 40px;
	}

	.header_title {
		font-size: 30px;
		font-weight: bold;
		flex: 1;
		text-align: center;
	}

	.body_part2 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part3 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.body_part4 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
	}
</style>
<style>
	.print-col-black {
		background-color: black;
		color: #fff;
	}

	.print-col-cell {}
</style>
<script>
	import {
		jsPDF
	} from "jspdf";
	import html2canvas from 'html2canvas';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			mainForm: {
				default: () => {
					return null
				}
			},
			name: {
				type: String,
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				loading: false,
				printShow: false,
				printObj: {
					id: "print_content", // 这里是要打印元素的ID
					popTitle: "&nbsp", // 打印的标题
					extraCss: '', // 打印可引入外部的一个 css 文件
					extraHead: "", // 打印头部文字
					preview: false,
					previewTitle: '报价单预览'
				},
				companys: [],
				company: '',
				companyaddress: '',
				mark: '',
				staffphone: '',
				director: [],
				tableData: [],
				collectionData: [],
				price: 0,
				offerphone:null,
				infoData: [
					{
						id: 1,
						a: '报价单编号',
						b: '',
						c: '',
						d: '',
						e: '',
						f: '报价日期',
						g: '',
						h: ''
					},
					{
						id: 2,
						a: '销售姓名',
						b: '',
						c: '',
						d: '销售电话',
						e: '',
						f: '',
						g: '',
						h: ''
					},
					{
						id: 3,
						a: '客户ID',
						b: '',
						c: '客户公司',
						d: '',
						e: '',
						f: '手机号',
						g: ''
					},
					{
						id: 4,
						a: '客户地址',
						b: '',
						c: '',
						d: '',
						e: '',
						f: '',
						g: '有效期',
						h: '10天'
					},
				],
				resData: [{
					id: 1,
					a: '总重量(kg)',
					b: '',
					c: '总数量',
					d: '',
					e: '总计金额',
					f: ''
				}, {
					id: 2,
					a: '快递',
					b: '',
					c: '额外费用',
					d: ''
				}],
				mergeCells: [{
						row: 0,
						col: 1,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 0,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 1,
						col: 1,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 1,
						col: 4,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 2,
						col: 3,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 2,
						col: 6,
						rowspan: 1,
						colspan: 2
					},
					{
						row: 3,
						col: 1,
						rowspan: 1,
						colspan: 5
					},
				],
				seal:''
			}
		},
		created() {
			this.$api.company.list(this.companyid).then((res) => {
				this.companys = res.list.reverse()
				this.init()

			})

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},

		methods: {
			getEmunValue(field, value) {
				return window.systemMethods.getEmunValue(field, value)
			},
			init() {

				this.mainData = this.mainForm.fApi.formData()
				console.log(this.mainData)



				this.price = parseFloat(this.mainData.price)
				let obj = {
					collectionaccount: this.mainData.companyname,
					amount: this.price,
					invoiceattr: this.mainData.invoicetype,
					// tax:parseFloat(this.mainData.tax).toFixed(2)
					tax: this.mainData.tax ? (this.mainData.invoicetype == 331 ? 13 : 1) : 0
				}
				// console.log(obj)
				this.collectionData.push(obj)
				// if (this.mainData.Includingtax == 3) {
				// 	this.price = parseFloat(this.mainData.pretaxprice)
				// } else {
				// 	this.price = parseFloat(this.mainData.price)
				// }

				this.tableData = this.mainForm.fApi.el('$son_offer_goods').store.table.getTableData().fullData
				this.mark = this.mainData.mark
				this.infoData[0].b = this.mainData.code

				this.infoData[0].g = window.systemMethods.timestampToDate(this.mainData.commit_time)
				this.infoData[2].b = this.mainData.customername
				this.infoData[2].d = this.mainData.customercompany
				this.infoData[2].g = this.mainData.customerphone
				this.infoData[3].b = this.mainData.customeraddress


				this.resData[0].b = this.mainData.weight
				this.resData[0].d = this.mainData.num
				this.resData[0].f = this.price
				this.resData[1].b = window.systemMethods.getparcel(this.mainData.parcelid)
				this.resData[1].d = this.mainData.additionalcosts

				
				let request = [this.getdetail(),this.getconfig(),this.getseal()]
				Promise.all(request).then((res)=>{
					// console.log(res)
					if(res[0]){
						this.infoData[1].b = res[0].name
						this.infoData[1].e = res[0].phone
						this.staffphone = res[0].phone
						this.director = res[0].director
						this.company = this.mainData.companyname
						this.companyaddress = this.mainData.companyaddress
						this.printShow = true
					}
					if(res[1]){
						let configdata = res[1].config?res[1].config:{}
						this.offerphone = configdata.offerphone
						// if(this.offerphone){
						// 	this.infoData[1].e = this.offerphone
						// }						
					}
					if(res[2]){
						if(res[2] && res[2].length){
							this.seal = res[2][0].path.replace("http://", "https://")
						}
					}
				})

				// this.$api.staff.getdetail(this.mainData.staffid).then((res) => {
				// 	this.infoData[1].b = res.name
				// 	this.infoData[1].e = res.phone
				// 	this.staffphone = res.phone
				// 	this.director = res.director
				// 	this.company = this.mainData.companyname
				// 	this.companyaddress = this.mainData.companyaddress
				// 	this.printShow = true
				// })
				// this.$api.config.get(0,{module:'offer'}).then((res)=>{
				// 	// console.log(res,'config')
				// 	let configdata = res.config?res.config:{}
				// 	this.offerphone = configdata.offerphone
				// })
				// this.$api.company.getseal(this.mainData.companyid).then((res) => {
				// 	if(res && res.length){
				// 		this.seal = res[0].path.replace("http://", "https://")
				// 	}
					
				// 	console.log(res)
				// })
				//this.collectionData = this.mainForm.fApi.el('$son_offer_collection').getTableData().fullData
			},
			
			getdetail(){
				return new Promise((reslove)=>{
					this.$api.staff.getdetail(this.mainData.staffid).then((res) => {
						reslove(res)
					},()=>{
						reslove(null)
					})
				})
			},
			getconfig(){
				return new Promise((reslove)=>{
					this.$api.config.get(0,{module:'offer'}).then((res) => {
						reslove(res)
					},()=>{
						reslove(null)
					})
				})
			},
			getseal(){
				return new Promise((reslove)=>{
					this.$api.company.getseal(this.mainData.companyid).then((res) => {
						reslove(res)
					},()=>{
						reslove(null)
					})
				})
			},
			
			headerCellClassName() {
				return 'print-col-black'
			},
			cellClassName() {
				return 'print-col-cell'
			},

			download() {
				this.loading = true
				html2canvas(this.$refs.printContent, {
					scale: 4,
					useCORS:true
				}).then((canvas) => {
					this.convertCanvasToImg(canvas)
					//this.loading = false
				})
			},
			downloadPDF() {
				this.loading = true
				let scale = 2
				html2canvas(this.$refs.printContent, {
					scale: scale,
					useCORS:true
				}).then((canvas) => {
					let timeStamp = new Date().getTime()
					let date = window.systemMethods.timestampToDate(timeStamp, true)
					let title = "报价单_" + this.mainData.customername + "_" + date
					let contentWidth = canvas.width / scale
					let contentHeight = canvas.height / scale
					let PDF = new jsPDF('p', 'pt', [contentWidth, contentHeight])
					let pdfWidth = PDF.internal.pageSize.getWidth()
					let pdfHeight = contentHeight / contentWidth * pdfWidth
					let pageData = canvas.toDataURL('image/jpeg', 1.0)
					PDF.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
					PDF.save(title + '.pdf')
					this.loading = false
				})
			},
			exportdata() {
				let tax = this.collectionData[0].tax
				let fullData = this.tableData
				let data = []
				let dataHead = [
					['', '报价单', '', '温州纳智紧固件有限公司'],
					['', 'QUOTATION', '', '专业生产螺丝，螺母，气动元件'],
					['', '', '', '专注履约时效，全品类供货，价格力'],
					[],
					['业务经理姓名：', this.infoData[1].b, '业务手机：', this.infoData[1].e, '', '', '报价单编码：', this.infoData[0].b],
					['客户公司：', this.infoData[2].d, '', '', '', '', '日期：', this.infoData[0].g],
					['客户地址：', this.infoData[3].b, '', '', '', '', '总重量约(kg)：', this.resData[0].b],
					[],
					["序号", "产品编码", "产品名称", "规格", "数量", "单位", tax ? "单价(含税)" : "单价", tax ? "金额(含税)" : "金额"],
				];
				let dataBody = []
				fullData.forEach((item, index) => {
					let arr = [
						index + 1,
						item.goodscode,
						item.goodsname,
						item.goodsmodel,
						item.num,
						window.systemMethods.getEmunValue('unit',item.goodsunit),
						tax ? item.taxfreight : item.pretaxfreight,
						item.amount,
						item.mark,
					]
					dataBody.push(arr)
				})
				let dataFoot = [
					[],
					['', '额外费用', this.resData[1].d, '', '', '', '金额总计', this.resData[0].f],
					['', '备注：', this.mark, '', '', '', '', ''],
					['', '以上价格：', '含运费', tax ? (tax == 13 ? '含税含13%增值税专用发票' : '含税含1%普通发票') : '不含税', '', '', '', ''],
					[],
					[],
					['', '交货期：', '全额付款后，标准件产品默认72小时内发货', '', '', '', '', '报价有效期 ：15天'],
					[],
					['', '所属公司：' + this.company ? this.company : (this.companys[0] ? this.companys[0].name : ''), '',
						'', '', '', '', ''
					],
					['', '公司地址：' + this.companyaddress ? this.companyaddress : (this.companys[0] ? this.companys[0]
						.address : ''), '', '', '', '', '', ''],
					['', '上级主管电话： 17336218869', '', '', '', '', '', ''],
					['', '禁止客服私收货款，投诉热线 13388540256 投诉成功奖励500元', '', '', '', '', '', ''],
				];
				data = data.concat(dataHead)
				data = data.concat(dataBody)
				data = data.concat(dataFoot)
				let wb = this.$XLSX.utils.book_new(); // 创建一个新工作簿
				let ws = this.$XLSX.utils.aoa_to_sheet(data) // 将数据转换为工作表
				// ws['B1'].s = {
				// 	font: {
				// 		bold: true,
				// 		sz: 18
				// 	}
				// }
				// ws['B2'].s = ws['B1'].s
				//let map = ['A', 'B', 'C', 'D', 'E', 'F', 'G','H']
				// let border = {
				// 	border: {
				// 		top: {
				// 			style: 'thin',
				// 			color: {
				// 				rgb: '000000'
				// 			}
				// 		},
				// 		bottom: {
				// 			style: 'thin',
				// 			color: {
				// 				rgb: '000000'
				// 			}
				// 		},
				// 		left: {
				// 			style: 'thin',
				// 			color: {
				// 				rgb: '000000'
				// 			}
				// 		},
				// 		right: {
				// 			style: 'thin',
				// 			color: {
				// 				rgb: '000000'
				// 			}
				// 		}
				// 	}
				// }
				// for (let i = 0; i <= dataBody.length; i++) {
				// 	for (let j = 0; j < map.length; j++) {
				// 		ws[map[j] + (i + 9)].s = border
				// 	}
				// }
				// ws['B20'].s = border
				// ws['C20'].s = border
				// ws['G20'].s = border
				// ws['H20'].s = border


				this.$XLSX.utils.book_append_sheet(wb, ws, "报价单") // 将工作表添加到工作簿
				this.$XLSX.writeFile(wb, "报价单.xlsx")
			},
			convertCanvasToImg(canvas) {
				let myBlob = this.dataURLtoBlob(canvas.toDataURL('img/png', 1))
				let myUrl = URL.createObjectURL(myBlob)
				this.downImg(myUrl)
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			downImg(url) {
				let timeStamp = new Date().getTime()
				let date = window.systemMethods.timestampToDate(timeStamp, true)
				let a = document.createElement("a")
				let clickEvent = document.createEvent("MouseEvents")
				a.setAttribute("href", url)
				a.setAttribute("download", "报价单_" + this.mainData.customername + "_" + date)
				a.setAttribute("target", '_blank')
				clickEvent.initEvent('click', true, true)
				a.dispatchEvent(clickEvent)
				this.loading = false
			},
			back() {
				this.$emit('back')
			}
		},
		components: {

		}
	}
</script>
